import { IPermission } from "@/interfaces";

export const validatePermission = ({
  name,
  description,
  rights,
}: IPermission): string[] => {
  const validationMessages = [];

  if (!name) {
    validationMessages.push("Permission requires a name");
  }

  if (!description) {
    validationMessages.push("Permission requires a description");
  }

  if (!rights?.length) {
    validationMessages.push("Permission requires right(s)");
  }

  return validationMessages;
};
